import { render, staticRenderFns } from "./CurrentLpo__resultTable1.vue?vue&type=template&id=6e636246&scoped=true&"
import script from "./CurrentLpo__resultTable1.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__resultTable1.vue?vue&type=script&lang=js&"
import style0 from "@/style/tables.scss?vue&type=style&index=0&id=6e636246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e636246",
  null
  
)

export default component.exports